module.exports = __webpack_public_path__ + "img/manda_012.e2652c05.png";